import { axiosInstance, overrideHeader } from '.';

export const getPurchaseList = () => {
  overrideHeader();
  return axiosInstance.get('/users/purchases');
};
